angular.module('bmsApp.dashboard').controller('DashboardBusinessPerformanceCtrl', function ($scope,
																							$timeout,
																							$q,
																							MMEnquiryCleanTypeSvc,
																							DashboardApiSvc,
																							FeedbackSvc,
																							$window,
																							$modal) {

	angular.extend($scope.data, {
		homesCleaned: {
			homesCleaned: null,
			cleaners: null,
			hours: null,
			loaded: false
		},
		mileageOverview: {
			mileageValue: null,
			loaded: false
		},
		jobFinance: {
			jobValue: null,
			jobPay: null,
			loaded: false
		},
		cleanFrequencyRevenueSplit: {
			cleanFrequencyRevenueSplit: null,
			loaded: false
		},
		treatmentBreakdown: {
			treatmentCoverage: null,
			treatmentCount: null,
			loaded: false
		},
		productBreakdown: {
			productUsage: null,
			loaded: false
		},
		enquiryRejectedReasonBreakdown: {
			enquiryRejectedReasonBreakdown: null,
			filters: {
				clean_type: null
			},
			loaded: false
		},
		customerInactiveReasonBreakdown: {
			customerInactiveReasonBreakdown: null,
			loaded: false
		},
		jobStats: {
			lastWeekEarningsPerInterval: 0,
			thisWeekEarningsPerInterval: 0,
			cleansMadeInactiveCount: 0,
			cleansMadeInactiveLostRevenue: 0
		},
		employeeEarnings: {
			loaded: false,
			employeeEarnings: null,
			targetLine: 40
		},
		enquirySource: {
			enquirySource: null,
			loaded: false
		},
		tilePopover: {
			open: function open(tileType) {
				var params = {
					tileType: tileType,
					filter: {
						fromDate: angular.copy($scope.data.dateRange.startDate),
						toDate: angular.copy($scope.data.dateRange.endDate),
						licenseId: angular.copy($scope.data.license.id)
					}
				};

				openTileBreakdownModal(params);
			},
			close: function close() {
				$scope.data.tilePopover.isOpen = false;
			}
		}
	});

	function openTileBreakdownModal(params) {
		var modalInstance = $modal.open({
			animation: true,
			templateUrl: 'ng/dashboard/templates/DashboardTileBreakdown.html',
			controller: 'DashboardTileBreakdownCtrl',
			size: 'md',
			resolve: {
				params: function () {
					return params;
				}
			}
		});
	}

	$scope.init = function () {
		var promises = {};
		if ($scope.isMM()) {
			$scope.loading = true;
			promises.mmEnquiryCleanTypeOptions = MMEnquiryCleanTypeSvc.options();
			$q.all(promises).then(function (responses) {
				if (angular.isDefined(responses.mmEnquiryCleanTypeOptions)) {
					$scope.mmEnquiryCleanTypeOptions = responses.mmEnquiryCleanTypeOptions.data.options;
				}
				$scope.loading = false;
			});
		}
	};

	$scope.init();

	$scope.$watchGroup(['data.license.id', 'data.dateRange.startDate', 'data.dateRange.endDate'], function () {
		$scope.actions.updateAll();
		loadIncome();

		if ($scope.isSM()) {
			loadEmployeeEarningsSummary();
			loadTravelTimeCost();
			loadMTDSummary();
		}

		if ($scope.isSM() || $scope.isMM()) {
			loadFeedback();
		}
	});

	function loadFeedback() {
		let params = {
			objectType: $scope.isSM() ? "App\\Models\\Bms\\Sm\\Job" : "App\\Models\\Bms\\Merrymaids\\Job",
			dateRange: $scope.data.dateRange,
			filter: {
				submitted: true,
			}
		};
		FeedbackSvc.index(params).then(function(response) {
			$scope.feedbackResponses = response.data.feedback_response_collection;
		});
	}

	function loadIncome() {
		var current_year = new Date().getFullYear();
		$scope.current_year = current_year - 1;
		$scope.mmYearOptions = [];
		var index = 0;
		for(var i = current_year - 8; i < current_year; i++){
			index++;
			$scope.mmYearOptions.push({id: index, label: i});
		}
		$scope.mmYearOptions.reverse();

		// Load the business income/forecast for previous/next 5 weeks
		var param = {
			licenseId: $scope.data.license ? $scope.data.license.id : 0,
			selectedYear: $scope.selectAnualRevenueyear ? $scope.selectAnualRevenueyear : 8
		};

		DashboardApiSvc.income(param).then(function (response) {
			$scope.income = {
				crt_year: response.data.crt_year,
				prev_year: response.data.prev_year
			};
		});
	}

	$scope.onSelectedYear = function(year){
		$scope.loadingRevenue = true;
		var current_year = new Date().getFullYear();
		var param = {
			licenseId: $scope.data.license ? $scope.data.license.id : 0,
			selectedYear: year ? year : 8
		};
		DashboardApiSvc.income(param)
			.then(function (response) {
				$scope.loadingRevenue = false;
				$scope.income = {
					crt_year: response.data.crt_year,
					prev_year: response.data.prev_year
				};
			});
	}

	function loadEmployeeEarningsSummary() {

		var param = {
			licenseId: $scope.data.license ? $scope.data.license.id : 0,
			dateRange: $scope.data.dateRange,
		};
		DashboardApiSvc.employeeEarningsSummary(param).then(function (response) {
			$scope.employeeEarningsSummary = response.data.report;
		});
	}

	function loadTravelTimeCost() {

		var param = {
			licenseId: $scope.data.license ? $scope.data.license.id : 0,
			dateRange: $scope.data.dateRange,
		};
		DashboardApiSvc.travelTimeCost(param).then(function (response) {
			$scope.travelTimeCost = response.data.report;
		});
	}

	function loadMTDSummary() {
		//sm
		var param = {
			licenseId: $scope.data.license ? $scope.data.license.id : 0,
			dateRange: $scope.data.dateRange,
		};
		DashboardApiSvc.smMTDSummary(param).then(function (response) {
			$scope.smMonthSummary = response.data.report;
		});
	}

	angular.extend($scope.actions, {
		showFeedbackBreakdown: function() {
			FeedbackSvc.showFeedbackBreakdown($scope.feedbackResponses, $scope.data.dateRange);
		},
		loadHomesCleaned: function (chartObj) {
			$timeout(function () {
				if (chartObj) {
					chartObj.reflow();
				}
				if (!$scope.data.homesCleaned.homesCleaned) {
					$scope.actions.updateHomesCleaned();
				}
			}, 50);
		},
		loadMileageOverview: function (chartObj) {
			$timeout(function () {
				if (chartObj) {
					chartObj.reflow();
				}
				if (!$scope.data.mileageOverview.mileageValue) {
					$scope.actions.updateMileageOverview();
				}
			}, 50);
		},
		loadJobFinance: function (chartObj) {
			$timeout(function () {
				if (chartObj) {
					chartObj.reflow();
				}
				if (!$scope.data.jobFinance.jobValue) {
					$scope.actions.updateJobFinance();
				}
			}, 50);
		},
		loadCleanFrequencyRevenueSplit: function (chartObj) {
			$timeout(function () {
				if (chartObj) {
					chartObj.reflow();
				}
				if (!$scope.data.cleanFrequencyRevenueSplit.cleanFrequencyRevenueSplit) {
					$scope.actions.updateCleanFrequencyRevenueSplit();
				}
			}, 50);
		},
		loadTreatmentBreakdown: function (chartObj) {
			$timeout(function () {
				if (chartObj) {
					chartObj.reflow();
				}
				if (!$scope.data.treatmentBreakdown.treatmentCoverage) {
					$scope.actions.updateTreatmentBreakdown();
				}
			}, 50);
		},
		loadProductBreakdown: function (chartObj) {
			$timeout(function () {
				if (chartObj) {
					chartObj.reflow();
				}
				if (!$scope.data.productBreakdown.productUsage) {
					$scope.actions.updateProductBreakdown();
				}
			}, 50);
		},
		loadEnquiryRejectedReasonBreakdown: function (chartObj) {
			$timeout(function () {
				if (chartObj) {
					chartObj.reflow();
				}
				if (!$scope.data.enquiryRejectedReasonBreakdown.enquiryRejectedReasonBreakdown) {
					$scope.actions.updateEnquiryRejectedReasonBreakdown();
				}
			}, 50);
		},
		loadEnquirySource: function (chartObj) {
			$timeout(function () {
				if (chartObj) {
					chartObj.reflow();
				}
				if (!$scope.data.enquirySource.enquirySource) {
					$scope.actions.enquirySource();
				}
			}, 50);
		},
		loadCustomerInactiveReasonBreakdown: function (chartObj) {
			$timeout(function () {
				if (chartObj) {
					chartObj.reflow();
				}
				if (!$scope.data.customerInactiveReasonBreakdown.customerInactiveReasonBreakdown) {
					$scope.actions.updateCustomerInactiveReasonBreakdown();
				}
			}, 50);
		},
		loadEmployeeEarnings: function(chartObj) {
			$timeout(function () {
				if (chartObj) {
					chartObj.reflow();
				}
				if (!$scope.data.employeeEarnings.employeeEarnings) {
					$scope.actions.updateEmployeeEarnings();
				}
			}, 50);
		},
		updateEmployeeEarningsTargetLine: function(chartObj) {
			$timeout(function () {
					angular.extend($scope.charts.employeeEarnings.yAxis[0].plotLines[0], {
						value: parseInt($scope.data.employeeEarnings.targetLine)
					});

					$window.localStorage['employeeEarningsTargetLine'] = $scope.data.employeeEarnings.targetLine;

					if (chartObj) {
						chartObj.reflow();
					}

			}, 50);


		},
		updateAll: function () {
			if ($scope.isSM()) {
				updateChartData([
					// 'enquiryRejectedReasonBreakdown',
					// 'customerInactiveReasonBreakdown',
					'employeeEarnings',
					'enquirySource',
				]);
			}
			else if ($scope.isTG()) {
				updateChartData([
					'treatmentBreakdown',
					'productBreakdown',
					'customerInactiveReasonBreakdown',
				]);
			}
			else {
				updateChartData([
					'homesCleaned',
					'mileageOverview',
					'jobFinance',
					'cleanFrequencyRevenueSplit',
					'treatmentBreakdown',
					'productBreakdown',
					'enquiryRejectedReasonBreakdown',
					'customerInactiveReasonBreakdown',
					'jobStats'
				]);
			}
		},
		updateHomesCleaned: function () {
			updateChartData(['homesCleaned']);
		},
		updateMileageOverview: function () {
			updateChartData(['mileageOverview']);
		},
		updateJobFinance: function () {
			updateChartData(['jobFinance']);
		},
		updateCleanFrequencyRevenueSplit: function () {
			updateChartData(['cleanFrequencyRevenueSplit']);
		},
		updateTreatmentBreakdown: function () {
			updateChartData(['treatmentBreakdown']);
		},
		updateProductBreakdown: function () {
			updateChartData(['productBreakdown']);
		},
		updateEnquiryRejectedReasonBreakdown: function () {
			updateChartData(['enquiryRejectedReasonBreakdown']);
		},
		updateCustomerInactiveReasonBreakdown: function () {
			updateChartData(['customerInactiveReasonBreakdown']);
		},
		updateEmployeeEarnings: function() {
			updateChartData(['employeeEarnings']);
		},
		enquirySource: function() {
			updateChartData(['enquirySource']);
		}
	});

	function updateChartData(types) {
		types.push('jobStats');
		$scope.actions.applyFilter();
		if ($scope.data.loading === false && $scope.data.updating === false) {
			$scope.data.updating = true;
			var extraTypeFilters = {};
			angular.forEach($scope.data, function (value, key) {
				if (angular.isObject(value.filters)) {
					extraTypeFilters[key] = angular.copy(value.filters);
				}
			});

			DashboardApiSvc
				.chart({
					types: types,
					dateRange: $scope.data.dateRange,
					licenseId: ($scope.data.license ? $scope.data.license.id : null),
					extraTypeFilters: extraTypeFilters
				})
				.then(function (response) {
					if (types.indexOf('jobStats') > -1) {
						$scope.data.jobStats.thisWeekEarningsPerInterval = response.data.jobStats.thisWeekEarningsPerInterval;
						$scope.data.jobStats.lastWeekEarningsPerInterval = response.data.jobStats.lastWeekEarningsPerInterval;
						$scope.data.jobStats.cleansMadeInactiveCount = response.data.jobStats.cleansMadeInactiveCount;
						$scope.data.jobStats.cleansMadeInactiveLostRevenue = response.data.jobStats.cleansMadeInactiveLostRevenue;
					}
					if (types.indexOf('homesCleaned') > -1) {
						$scope.charts.homesCleaned = angular.copy($scope.chartTemplates.homesCleaned);
						$scope.charts.homesCleaned.xAxis.categories = response.data.categories;
						$scope.data.homesCleaned.homesCleaned = response.data.homesCleaned.homesCleaned;
						$scope.data.homesCleaned.cleaners = response.data.homesCleaned.cleaners;
						$scope.data.homesCleaned.hours = response.data.homesCleaned.hours;
						$scope.data.homesCleaned.loaded = true;
						$scope.charts.homesCleaned.series[0].data = response.data.homesCleaned.homesCleaned.data;
						$scope.charts.homesCleaned.series[1].data = response.data.homesCleaned.cleaners.data;
						$scope.charts.homesCleaned.series[2].data = response.data.homesCleaned.hours.data;
					}
					if (types.indexOf('mileageOverview') > -1) {
						$scope.charts.mileageOverview = angular.copy($scope.chartTemplates.mileageOverview);
						$scope.charts.mileageOverview.xAxis.categories = response.data.categories;
						$scope.data.mileageOverview.mileageValue = response.data.mileageOverview.mileageValue;
						$scope.data.mileageOverview.loaded = true;
						$scope.charts.mileageOverview.series[0].data = response.data.mileageOverview.mileageValue.data;
					}
					if (types.indexOf('jobFinance') > -1) {
						$scope.charts.jobFinance = angular.copy($scope.chartTemplates.jobFinance);
						$scope.charts.jobFinance.xAxis.categories = response.data.categories;
						$scope.data.jobFinance.jobValue = response.data.jobFinance.jobValue;
						$scope.data.jobFinance.jobPay = response.data.jobFinance.jobPay;
						$scope.data.jobFinance.loaded = true;
						$scope.charts.jobFinance.series[0].data = response.data.jobFinance.jobValue.data;
						$scope.charts.jobFinance.series[1].data = response.data.jobFinance.jobPay.data;
					}
					if (types.indexOf('cleanFrequencyRevenueSplit') > -1) {
						$scope.charts.cleanFrequencyRevenueSplit = angular.copy($scope.chartTemplates.cleanFrequencyRevenueSplit);
						$scope.data.cleanFrequencyRevenueSplit.cleanFrequencyRevenueSplit = response.data.cleanFrequencyRevenueSplit.cleanFrequencyRevenueSplit;
						$scope.data.cleanFrequencyRevenueSplit.loaded = true;
						$scope.charts.cleanFrequencyRevenueSplit.series[0].data = response.data.cleanFrequencyRevenueSplit.cleanFrequencyRevenueSplit.data;
					}
					if (types.indexOf('treatmentBreakdown') > -1) {
						$scope.charts.treatmentCoverage = angular.copy($scope.chartTemplates.treatmentCoverage);
						$scope.charts.treatmentCount = angular.copy($scope.chartTemplates.treatmentCount);
						$scope.data.treatmentBreakdown.treatmentCoverage = response.data.treatmentBreakdown.treatmentCoverage;
						$scope.data.treatmentBreakdown.treatmentCount = response.data.treatmentBreakdown.treatmentCount;
						$scope.data.treatmentBreakdown.loaded = true;
						$scope.charts.treatmentCoverage.series[0].data = response.data.treatmentBreakdown.treatmentCoverage.data;
						$scope.charts.treatmentCount.series[0].data = response.data.treatmentBreakdown.treatmentCount.data;
					}
					if (types.indexOf('productBreakdown') > -1) {
						$scope.charts.productUsage = angular.copy($scope.chartTemplates.productUsage);
						$scope.data.productBreakdown.productUsage = response.data.productBreakdown.productUsage;
						$scope.data.productBreakdown.loaded = true;
						$scope.charts.productUsage.series[0].data = response.data.productBreakdown.productUsage.data;
					}
					if (types.indexOf('enquiryRejectedReasonBreakdown') > -1) {
						$scope.charts.enquiryRejectedReasonBreakdown = angular.copy($scope.chartTemplates.enquiryRejectedReasonBreakdown);
						$scope.data.enquiryRejectedReasonBreakdown.enquiryRejectedReasonBreakdown = response.data.enquiryRejectedReasonBreakdown.enquiryRejectedReasonBreakdown;
						$scope.data.enquiryRejectedReasonBreakdown.loaded = true;
						$scope.charts.enquiryRejectedReasonBreakdown.series[0].data = response.data.enquiryRejectedReasonBreakdown.enquiryRejectedReasonBreakdown.data;
					}
					if (types.indexOf('enquirySource') > -1) {
						$scope.charts.enquirySource = angular.copy($scope.chartTemplates.enquirySource);
						$scope.data.enquirySource.enquirySource = response.data.enquirySource.sources;
						$scope.data.enquirySource.loaded = true;
						if (angular.isDefined(response.data.enquirySource.sources) && response.data.enquirySource.sources.data.length) {
							$scope.charts.enquirySource.series[0].data = response.data.enquirySource.sources.data;
						}

					}
					if (types.indexOf('customerInactiveReasonBreakdown') > -1) {
						$scope.charts.customerInactiveReasonBreakdown = angular.copy($scope.chartTemplates.customerInactiveReasonBreakdown);
						$scope.data.customerInactiveReasonBreakdown.customerInactiveReasonBreakdown = response.data.customerInactiveReasonBreakdown.customerInactiveReasonBreakdown;
						$scope.data.customerInactiveReasonBreakdown.loaded = true;
						$scope.charts.customerInactiveReasonBreakdown.series[0].data = response.data.customerInactiveReasonBreakdown.customerInactiveReasonBreakdown.data;
					}
					if (types.indexOf('employeeEarnings') > -1) {
						$scope.charts.employeeEarnings = angular.copy($scope.chartTemplates.employeeEarnings);
						if ($window.localStorage['employeeEarningsTargetLine']) {
							$scope.data.employeeEarnings.targetLine = $window.localStorage['employeeEarningsTargetLine'];
						}
						else {
							$scope.data.employeeEarnings.targetLine = 300;
						}

						angular.extend($scope.charts.employeeEarnings.yAxis[0].plotLines[0], {
							value: $scope.data.employeeEarnings.targetLine
						});

						$scope.charts.employeeEarnings.xAxis.categories = response.data.employeeEarnings.categories;
						$scope.data.employeeEarnings.employeeEarnings = response.data.employeeEarnings.earnings;
						$scope.data.employeeEarnings.loaded = true;
						$scope.charts.employeeEarnings.series = response.data.employeeEarnings.earnings.data;

					}
					$scope.data.updating = false;
				});
		}
	}

	// Chart configs -----------------------------------------------------------------------------------------------
	$scope.chartTemplates = {
		homesCleaned: {
			chart: {
				type: 'column'
			},
			title: {
				text: 'Homes Cleaned'
			},
			series: [
				{
					name: 'Homes Cleaned',
					data: [],
					yAxis: 0
				},
				{
					name: 'Cleaners',
					data: [],
					yAxis: 0
				},
				{
					name: 'Hours (Average)',
					data: [],
					yAxis: 1
				}
			],
			xAxis: {
				categories: []
			},
			yAxis: [
				{
					min: 0,
					title: {
						text: 'Count',
						style: {
							'fontWeight': 'bold'
						}
					}
				},
				{
					min: 0,
					title: {
						text: 'Hours',
						style: {
							'fontWeight': 'bold'
						}
					},
					opposite: true
				}
			],
			credits: {
				enabled: false
			}
		},
		mileageOverview: {
			chart: {
				type: 'line'
			},
			title: {
				text: 'Mileage Overview'
			},
			series: [
				{
					name: 'Mileage Value',
					data: [],
					tooltip: {
						valuePrefix: '£'
					}
				}
			],
			xAxis: {
				categories: []
			},
			yAxis: [
				{
					min: 0,
					title: {
						text: 'Value (£)',
						style: {
							'fontWeight': 'bold'
						}
					}
				}
			],
			credits: {
				enabled: false
			}
		},
		jobFinance: {
			chart: {
				type: 'line'
			},
			title: {
				text: 'Pay vs Job Value'
			},
			series: [
				{
					name: 'Job Value',
					data: [],
					tooltip: {
						valuePrefix: '£'
					}
				},
				{
					name: 'Pay',
					data: [],
					tooltip: {
						valuePrefix: '£'
					}
				}
			],
			xAxis: {
				categories: []
			},
			yAxis: [
				{
					min: 0,
					title: {
						text: 'Value (£)',
						style: {
							'fontWeight': 'bold'
						}
					}
				}
			],
			credits: {
				enabled: false
			}
		},
		cleanFrequencyRevenueSplit: {
			chart: {
				type: 'pie'
			},
			title: {
				text: 'Clean Frequency Revenue Split'
			},
			plotOptions: {
				pie: {
					dataLabels: {
						enabled: false
					},
					showInLegend: true
				}
			},
			tooltip: {
				pointFormat: '<b>£{point.y:,.2f}</b> ({point.percentage:.1f}%)'
			},
			series: [
				{
					name: 'Clean Frequency',
					data: []
				}
			],
			credits: {
				enabled: false
			}
		},
		treatmentCoverage: {
			chart: {
				type: 'pie'
			},
			title: {
				text: 'Treatment Coverage'
			},
			plotOptions: {
				pie: {
					dataLabels: {
						enabled: false
					},
					showInLegend: true
				}
			},
			tooltip: {
				pointFormat: 'Lawn Covered: <b>{point.y}m²</b> ({point.percentage:.1f}%)'
			},
			series: [
				{
					name: 'Treatment',
					data: []
				}
			],
			credits: {
				enabled: false
			}
		},
		treatmentCount: {
			chart: {
				type: 'pie'
			},
			title: {
				text: 'Treatment Frequency'
			},
			plotOptions: {
				pie: {
					dataLabels: {
						enabled: false
					},
					showInLegend: true
				}
			},
			tooltip: {
				pointFormat: 'Treatments: <b>{point.y}</b> ({point.percentage:.1f}%)'
			},
			series: [
				{
					name: 'Treatment',
					data: []
				}
			],
			credits: {
				enabled: false
			}
		},
		productUsage: {
			chart: {
				type: 'pie'
			},
			title: {
				text: 'Product Usage'
			},
			plotOptions: {
				pie: {
					dataLabels: {
						enabled: false
					},
					showInLegend: true
				}
			},
			tooltip: {
				pointFormat: 'Units Applied: <b>{point.y}</b> ({point.percentage:.1f}%)'
			},
			series: [
				{
					name: 'Product',
					data: []
				}
			],
			credits: {
				enabled: false
			}
		},
		enquiryRejectedReasonBreakdown: {
			chart: {
				type: 'pie'
			},
			title: {
				text: 'Enquiry Rejected Reasons'
			},
			plotOptions: {
				pie: {
					dataLabels: {
						enabled: false
					},
					showInLegend: true
				}
			},
			tooltip: {
				pointFormat: '<b>{point.y}</b> ({point.percentage:.1f}%)'
			},
			series: [
				{
					name: 'Reason',
					data: []
				}
			],
			credits: {
				enabled: false
			}
		},
		customerInactiveReasonBreakdown: {
			chart: {
				type: 'pie'
			},
			title: {
				text: 'Customer Inactive Reasons'
			},
			plotOptions: {
				pie: {
					dataLabels: {
						enabled: false
					},
					showInLegend: true
				}
			},
			tooltip: {
				pointFormat: '<b>{point.y}</b> ({point.percentage:.1f}%)'
			},
			series: [
				{
					name: 'Customer Inactive Reason',
					data: []
				}
			],
			credits: {
				enabled: false
			}
		},
		employeeEarnings: {
			chart: {
				type: 'line'
			},
			title: {
				text: 'Employee Earnings'
			},
			series: [
				{
					name: 'Mileage Value',
					data: [],
					tooltip: {
						valuePrefix: '£'
					}
				}
			],
			xAxis: {
				categories: [],
			},
			yAxis: [
				{
					min: 0,
					title: {
						text: 'Value (£)',
						style: {
							'fontWeight': 'bold'
						}
					},

					plotLines: [{
						color: 'gray', // Color value
						label: 'Target',
						dashStyle: 'shortdash', // Style of the plot line. Default to solid
						value: 300,
						width: 2 // Width of the line
					}]
				}
			],
			credits: {
				enabled: false
			}
		},
		enquirySource: {
			chart: {
				type: 'pie'
			},
			title: {
				text: 'Enquiry Source'
			},
			plotOptions: {
				pie: {
					dataLabels: {
						enabled: false
					},
					showInLegend: true
				}
			},
			tooltip: {
				pointFormat: '({point.percentage:.0f}%)'
			},
			series: [
				{
					name: 'Customer Source',
					data: []
				}
			],
			credits: {
				enabled: false
			}
		},
	};

	// Initialised charts ------------------------------------------------------------------------------------------
	$scope.charts = {};
	$scope.chartObjs = {};

});
